import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
// import { propTypes as rowPropTypes } from './row';
import StandardCard from '../card/standard_card';
import getUniqueKeyForCard from '../../utils/getUniqueKeyForCard';
import {map, take} from 'lodash';

export default function ThreeStandardCards(props, context) {
  const { archivesState, cards, dataAttributes, moduleID,
    page_type, type, moduleType, moduleTitle } = props;
  const { isPreviewPage, location } = context;
  const threeStandardCards = map(take(cards, 3), (card, i) => {
    const isLastInRow = (i + 1) % 3 === 0;
    const className = classNames('standard', { 'last-in-row': isLastInRow });
    const key = getUniqueKeyForCard(card, isPreviewPage);
    const cardProps = {
      ...card, className, key, archivesState, moduleID, page_type,
      isLastInRow, rowType: type, moduleType, location, moduleTitle
    };
    return <StandardCard {...cardProps} />;
  });

  return (
    <div className="row" {...dataAttributes} >
      {threeStandardCards}
    </div>
  );
}

// ThreeStandardCards.propTypes = Object.assign({ ...rowPropTypes }, {
//   dataAttributes: PropTypes.object.isRequired
// });

ThreeStandardCards.defaultProps = {
  dataAttributes: {}
};

ThreeStandardCards.contextTypes = {
  isPreviewPage: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired
};
